export const removePolishCharacters = (str: string) => {
    const from = "ąćęłńóśźżĄĆĘŁŃÓŚŹŻ";
    const to = "acelnoszzACELNOSZZ";

    for (let i = 0, len = from.length; i < len; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    return str;
}